<template>
    <div>
        <div v-for="(field_value, label) in custom_fields" class="mb-1">

            <div v-if="typeof field_value === 'string' && !field_value.includes('<')">
                <label class="text-muted">{{ label }}:</label> {{ field_value }}
            </div>

            <div v-else-if="typeof field_value === 'string' && field_value.includes('<')">
                <label class="text-muted">{{ label }}:</label> <div v-html="field_value"></div>
            </div>

            <div v-else-if="Array.isArray(field_value)">
                <label class="text-muted">{{ label }}:</label> <span v-for="(val, i) in field_value"><span v-if="i > 0">, </span>{{ val }}</span>
            </div>

            <div v-else-if="typeof field_value === 'object' && field_value.EmployeeId">
                <label class="text-muted">{{ label }}:</label> <router-link :to="`/employees/view/${field_value.EmployeeId}`">{{ field_value.FirstName }} {{ field_value.LastName }} - {{ field_value.EmployeeNumber }}</router-link>
            </div>

            <div v-else-if="typeof field_value === 'object' && field_value.UserId">
                <label class="text-muted">{{ label }}:</label> <router-link :to="`/users/view/${field_value.UserId}`">{{ field_value.FirstName }} {{ field_value.LastName }} - {{ field_value.email }}</router-link>
            </div>

            <div v-else-if="typeof field_value === 'object' && field_value.JobsiteId">
                <label class="text-muted">{{ label }}:</label> <router-link :to="`/jobsites/view/${field_value.JobsiteId}`">{{ field_value.JobsiteNumber }} - {{ field_value.JobsiteName }}</router-link>
            </div>

            <div v-else-if="typeof field_value === 'object' && field_value.equipment_id">
                <label class="text-muted">{{ label }}:</label> <router-link :to="`/equipment/view/${field_value.equipment_id}`">{{ field_value.model_number }} - {{ field_value.serial_number }} ({{ field_value.equipment_type_name }})</router-link>
            </div>

            <div v-else-if="typeof field_value === 'object' && field_value.file_id">
                <label class="text-muted">{{ label }}:</label> <a :href="`/files/view/${field_value.file_id}`" target="_blank">{{ field_value.file_name }}</a>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        props: {
            custom_fields: {
                type: Object,
                required: true
            },
        },

        data() {
            return {

            }
        },
    }
</script>
